export enum Environments {
  DEVELOP = 'development',
  PRODUCTION = 'production',
  PREPROD = 'preprod',
  STAGING = 'staging',
  UAT = 'uat',
}
